
<template>
  <div>
    <!-- ===== ESCENA INICIAL: MOÑO SUPERIOR ===== -->
    <div class="lux-escena-final" aria-hidden="true">
      <img
        class="lux-flores-top"
        src="@/assets/moñii.png"
        alt=""
        loading="lazy"
        disabled
        decoding="async"
      />
    </div>

    <section class="evento-lux">
      <!-- ===== TARJETA 1: CEREMONIA RELIGIOSA ===== -->
      <article ref="card1" class="card" aria-label="Ceremonia Religiosa">
        <img class="icono" src="@/assets/9.avif" alt="" />
        <h3 class="titulo-script">Ceremonia Religiosa</h3>
        <p class="lugar">MONICA ROMAN CATHOLIC PARISH CHURCH</p>

        <!-- 📸 Nuevo Contenedor para Foto Circular -->
        <div class="contenedor-circular">
          <img class="foto-lugar-circulo" src="@/assets/igle.png" alt="Monica Roman Catholic Parish Church" />
        </div>

        <p class="lugar2">212 W Medina Rd, Tucson, Arizona.</p>
        <p class="direccion"></p>
        <p class="hora">4:00 PM</p>

        <a
          ref="btn1"
          class="btn-rosa"
          href="https://maps.app.goo.gl/8Khd5sVs3PZvrUdk9"
          target="_blank"
          rel="noopener"
        >
          ¿Cómo llegar?
          <span class="sheen" aria-hidden="true"></span>
        </a>
      </article>

      <!-- ===== TARJETA 2: CELEBRACIÓN (RECEPCIÓN) ===== -->
      <article ref="card2" class="card" aria-label="Recepción">
        <img class="icono" src="@/assets/10.avif" alt="" />
        <h3 class="titulo-script">Celebración</h3>
        <p class="lugar">ZONA 520</p>

        <!-- 📸 Nuevo Contenedor para Foto Circular -->
        <div class="contenedor-circular">
          <img class="foto-lugar-circulo" src="@/assets/sal.png" alt="Crown Jewel Ballroom" />
        </div>

        <p class="lugar2"> 3672 s 16 th ave Tucson, Arizona.</p>
        <p class="direccion"></p>
        <p class="hora">6:00 PM</p>

        <a
          ref="btn2"
          class="btn-rosa"
          href="https://maps.app.goo.gl/tQmw12jnxH2zWKuL6"
          target="_blank"
          rel="noopener"
        >
          ¿Cómo llegar?
          <span class="sheen" aria-hidden="true"></span>
        </a>
      </article>
    </section>

    <!-- ===== ESCENA FINAL: DEGRADADO + MOÑO INFERIOR ===== -->
    <div class="lux-escena-final" aria-hidden="true">
      <div class="lux-degradado"></div>
      <img
        class="lux-flores"
        src="@/assets/moñii.png"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card1 = ref(null)
    const btn1 = ref(null)
    const card2 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {
      const $ = gsap.utils.selector(cardEl)
      
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          end: 'bottom 60%',
          scrub: 0.25
        },
        defaults: { ease: 'power2.out', duration: 0.4 }
      })

      tl.from(cardEl, {
        opacity: 0,
        y: 30,
        filter: 'blur(5px)'
      })
      .from($('.icono'), {
        opacity: 0,
        y: 20,
        scale: 0.8
      })
      .from($('.titulo-script'), {
        opacity: 0,
        y: 20
      })
      .from($('.lugar'), {
        opacity: 0,
        x: -20
      })
      .from($('.contenedor-circular'), {
        opacity: 0,
        y: 20,
        scale: 0.9,
        duration: 0.6
      })
      .from($('.lugar2'), {
        opacity: 0,
        x: 20
      })
      .from($('.hora'), {
        opacity: 0,
        scale: 0.9
      })
      .from(btnEl, {
        opacity: 0,
        y: 15,
        scale: 0.95
      })

      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl?.querySelector('.sheen')
          if (shine) {
            gsap.fromTo(
              shine,
              { xPercent: -110, opacity: 0 },
              { xPercent: 140, opacity: 1, duration: 0.8, ease: 'power2.inOut' }
            )
          }
        }
      })
    }

    onMounted(() => {
      if (card1.value && btn1.value) {
        animCard(card1.value, btn1.value)
      }
      if (card2.value && btn2.value) {
        animCard(card2.value, btn2.value)
      }
    })

    return { 
      card1, 
      btn1, 
      card2, 
      btn2
    }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root {
  --rosa: #c6dff4;
  --rosa-alt: #c3def0;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux {
  min-height: 100%;
  padding: 28px 18px 64px;
  background: #f3f7fd;
  display: grid;
  gap: 40px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card {
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;  
  background: #f3f7fd;
  padding: 24px 20px 28px;
  text-align: center;
  overflow: hidden;
}

/* Icono discreto */
.icono {
  width: 52px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.05));
  opacity: 0.92;
}

/* Tipos */
.titulo-script {
  font-family: 'titulos', cursive;
  font-weight: 400;
  font-size: 50px;
  color: var(--tinta);
  letter-spacing: 0.4px;
  margin: 4px 0 8px;
}
.hora {
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 16px; /* Se redujo el margen superior para evitar huecos */
}
.lugar2 {
  font-family: 'padres', serif;
  font-size: 18px;
  color: #000;
  font-weight: 500;
  margin: 0 0 4px; /* Eliminado el margen superior heredado y compactado hacia la hora */
  letter-spacing: 0.1em;
}
.lugar {
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 600;
  margin: 0 0 16px;
  letter-spacing: 0.14em;
}

/* 🟢 Estilos para lograr el Círculo Perfecto */
.contenedor-circular {
  width: 250px;       /* Ancho fijo del círculo */
  height: 250px;      /* Alto fijo del círculo (debe ser igual al ancho) */
  border-radius: 50%;  /* Hace el contenedor circular */
  overflow: hidden;    /* Recorta la imagen dentro del círculo */
  margin: 10px auto 14px; /* Ajustado el margen inferior de 20px a 14px */
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1); /* Sombra elegante */
  border: 3px solid #ffffff; /* Borde blanco sutil para destacar */
}

.foto-lugar-circulo {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Importante: la imagen llena el círculo sin deformarse */
  display: block;
}

.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 90%;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: rgb(36, 74, 156);
  color: #ffffff;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 16px;
  line-height: 1;
  box-shadow:
    0 8px 16px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    filter 0.16s ease;
  border: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 0;
}
.btn-rosa:hover {
  transform: translateY(-1px);
  box-shadow:
    0 12px 20px rgba(0, 0, 0, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  filter: brightness(1.03);
}
.btn-rosa .sheen {
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  transform: rotate(20deg);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
  mix-blend-mode: screen;
  opacity: 0;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .card {
    padding: 16px 14px 20px; /* Menos espacio interno en pantallas muy pequeñas */
  }
  .titulo-script {
    font-size: 36px; /* Ajustado de 32px a 36px para que no sea excesivamente pequeño */
    margin: 2px 0 4px;
  }
  .hora {
    font-size: 22px;
    margin: 0 0 12px;
  }
  .lugar {
    font-size: 18px; /* Ajustado de 16px a 18px para mejor lectura */
    margin: 0 0 10px;
  }
  .lugar2 {
    font-size: 15px;
    margin: 0 0 2px;
  }
  .contenedor-circular {
    width: 170px; /* Incrementado de 120px a 170px para que luzca bien sin ser minúsculo */
    height: 170px;
    margin: 6px auto 10px;
  }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}

/* ===== ESCENAS GRÁFICAS (MOÑOS) ===== */
.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  overflow: visible;
  background: #f3f7fd;
}

.lux-flores-top {
  width: min(460px, 40%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.08));
  opacity: 0.98;
  margin-top: 30px;
  margin-bottom: -10px;
}

.lux-degradado {
  width: 100%;
  height: 180px;
  background: linear-gradient(
    to top,
    #b3bfcc 0%,
    rgba(213, 232, 246, 0.85) 35%,
    rgba(246, 213, 229, 0.35) 65%,
    rgba(246, 213, 229, 0) 100%
  );
}

.lux-flores {
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  width: min(460px, 40%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.08));
  opacity: 0.98;
}
</style>

```